import {SET_NETWORK_ERROR, SET_SPEED_AND_CODE} from "./network-answer";
import store from "../localStorage";

export default class networkAnswerManager {
    static setSpeedAndCode = (speed, code) => store.dispatch({type: SET_SPEED_AND_CODE, network_speed: speed, response_code: code});
    static setNetworkError = (network_error) => store.dispatch({type: SET_NETWORK_ERROR, network_error: network_error});
    static getNetworkSpeed = () => store.getState().networkAnswer.network_speed;
    static getResponseCode = () => store.getState().networkAnswer.response_code;
    static getNetworkError = () => store.getState().networkAnswer.network_Error;
}